export default {
  CONNECTED_TO_CHANNEL: 'ACTION_CABLE_CONNECTED_TO_CHANNEL',
  DATA_RECEIVED_FROM_CHANNEL: 'ACTION_CABLE_DATA_RECEIVED_FROM_CHANNEL',
  DISCONNECTED_FROM_CHANNEL: 'ACTION_CABLE_DISCONNECTED_FROM_CHANNEL'
}
